import { ViewColumn } from '@mui/icons-material'
import React, { useState } from 'react'
import documentServices from '../services/documentServices';

function DocumentSearchComponent({setDocumentId}) {

  const [documentIdInput,setDocumentIdInput] = useState("");
  const [barcodeInput,setBarcodeInput] = useState("");

  const handleDocumentIdInputKeyUp = (e) =>{
    if(e.key === 'Enter') {
        e.preventDefault();
        setDocumentId(documentIdInput)
    }
  }

  const handleBarcodeInputKeyUp = (e) =>{
    if(e.key === 'Enter') {
        e.preventDefault();
        documentServices.getDocumentIdByBarcode(barcodeInput).then(res=>{
          if(res.data !== null ){
            setDocumentId(res.data.documentId);
          }
          console.log(res.data);
        }).catch(error=>{

        }).finally(()=>{

        })
    }
  }

  return (
    <div className="row my-2">
      <div className='col-md-5'>
        <div className="input-group">
          <input 
            type="text" className="form-control" placeholder="Enter Document Id" 
            value={documentIdInput} 
            onChange={(e)=>setDocumentIdInput(e.target.value)} 
            onKeyUp={handleDocumentIdInputKeyUp}
          />
          <button class="btn btn-outline-primary" type="button">Search</button>
        </div>
      </div>
      <div className='col-md-2'><div className='text-center fw-bold my-2'>OR</div></div>
      <div className='col-md-5'>
        <div className="input-group">
          <input 
            type="text" className="form-control" placeholder="Scan Barcode to search "
            value={barcodeInput} 
            onChange={(e)=>setBarcodeInput(e.target.value)} 
            onKeyUp={handleBarcodeInputKeyUp}
          />
          <span className="input-group-text"><ViewColumn/></span>
        </div>
      </div>
    </div>
  )
}

export default DocumentSearchComponent